import { Fragment, memo, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { useWindowWidth } from "@react-hook/window-size";
import { imageUrlCheck } from "../../../../utils/utils";
import TrailerModal from "../../../../Components/Modals/TrailerModal";
import { getTrailer } from "../../../Trailer/service";
import Translate from "../../../../Components/Multilanguage/Translate";

const HomeHeroSlider = memo(({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const themeSchemeDirection = '';
  const [toggler, setToggler] = useState(false);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [trailerLink, setTrailerLink] = useState();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const windowSize = useWindowWidth();

  const replaceImage = (error) => {
    error.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
  };

  const trailerButtonHandle = async (teaser) => {
    const response = await getTrailer(appInfo, teaser);
    setTrailerLink(response.data.data.teaser);
    setToggler(!toggler);
  };

  return (
    <Fragment>
      <Swiper
        key={themeSchemeDirection}
        dir={themeSchemeDirection}
        navigation={{
          prevEl: ".home-hero-slider__nav-prev",
          nextEl: ".home-hero-slider__nav-next",
        }}
        slidesPerView={1}
        modules={[Navigation, Autoplay]}
        loop
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        className="home-hero-slider"
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="home-hero-slider__image-wrapper">
              {imageUrlCheck(item?.banner || item?.logo) ? (
                <img
                  src={windowSize > 480 ? item?.banner : item?.banner_portrait}
                  alt="Banner"
                  onError={replaceImage}
                  className="home-hero-slider__image"
                />
              ) : (
                <img
                  src={windowSize > 480 
                  ? `${process.env.REACT_APP_IMAGE_URL}${item?.banner}` 
                  : `${process.env.REACT_APP_IMAGE_URL}${item?.banner_portrait}`}
                  alt="Banner"
                  onError={replaceImage}
                  className="home-hero-slider__image"
                />
              )}
            </div>
            <div className="home-hero-slider__content-container">
              <div className="home-hero-slider__content">
                <div className="home-hero-slider__text">
                  <h1 className="home-hero-slider__title">{item?.show_name}</h1>
                  <div className="home-hero-slider__meta">
                    <span className="home-hero-slider__duration">{item?.duration_text}</span>
                  </div>
                  <p className="home-hero-slider__synopsis">{item?.synopsis}</p>

                  {item?.categories?.length > 0 && (
                    <div className="home-hero-slider__tags">
                      <div className="home-hero-slider__genres">
                        <Translate textKey="genres" />:
                        <Link className="home-hero-slider__link">
                          {item?.categories[0].category_name}
                        </Link>
                      </div>
                      <div className="home-hero-slider__category-tags">
                        <Translate textKey="tags" />:
                        {item?.categories.map((category, idx) => (
                          <Link
                            key={idx}
                            to={category?.key ? `/category/${category.key}` : "#"}
                            className="home-hero-slider__link"
                          >
                            {category.category_name}{idx !== item?.categories?.length - 1 ? "," : ""}{" "}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="home-hero-slider__button-wrapper">
                    <Link
                      to={`/show-details/${item?.vanity_url}`}
                      className="home-hero-slider__button"
                    >
                      <span className="home-hero-slider__button-text">
                        <Translate textKey="play_now" />
                      </span>
                      <i className="fa-solid fa-play"></i>
                    </Link>
                  </div>
                </div>

                {item?.teaser_vanity_url && (
                  <div className="home-hero-slider__trailer">
                    <Link
                      to="#"
                      className="home-hero-slider__trailer-link"
                      onClick={() => trailerButtonHandle(item?.teaser_vanity_url)}
                    >
                      <svg
                        version="1.1"
                        viewBox="0 0 213.7 213.7"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                      <polygon
                        className="triangle"
                        fill="none"
                        strokeWidth="7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeiterlimit="10"
                        points="73.5,62.5 148.5,105.8 73.5,149.1 "
                      ></polygon>
                      <circle
                        className="circle"
                        fill="none"
                        strokeWidth="7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeiterlimit="10"
                        cx="106.8"
                        cy="106.8"
                        r="103.3"
                      ></circle>
                      </svg>
                      <span className="home-hero-slider__trailer-text">
                        <Translate textKey="watch_trailer" />
                      </span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}

        <div className="home-hero-slider__nav home-hero-slider__nav-prev">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="44" height="44" fill="none" stroke="currentColor">
            <circle r="20" cy="22" cx="22"></circle>
            <polyline points="24,14 16,22 24,30" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="home-hero-slider__nav home-hero-slider__nav-next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="44" height="44" fill="none" stroke="currentColor">
            <circle r="20" cy="22" cx="22"></circle>
            <polyline points="20,14 28,22 20,30" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

      </Swiper>

      {toggler && trailerLink !== null && (
        <TrailerModal teaser={trailerLink} setIsTrailer={setToggler} appInfo={appInfo} />
      )}
    </Fragment>
  );
});

HomeHeroSlider.displayName = "HomeHeroSlider";
export default HomeHeroSlider;
